var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQueueScreenArrowRightGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 54,
    viewBox: "0 0 64 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8908 0.558489L63.4021 25.5295C63.7847 25.9197 63.9995 26.4486 63.9995 27C63.9995 27.5514 63.7847 28.0803 63.4021 28.4705L38.8908 53.4415C38.5036 53.8091 37.9915 54.0092 37.4623 53.9997C36.9331 53.9902 36.4282 53.7718 36.054 53.3905C35.6797 53.0093 35.4654 52.4949 35.456 51.9558C35.4467 51.4167 35.6431 50.8949 36.0039 50.5005L57.0258 29.0809L2.04212 29.0809C1.50039 29.0809 0.980841 28.8617 0.597777 28.4714C0.214713 28.0812 -0.000489437 27.5519 -0.000489461 27C-0.000489485 26.4481 0.214713 25.9188 0.597777 25.5286C0.980841 25.1383 1.50039 24.9191 2.04212 24.9191L57.0258 24.9191L36.0039 3.49952C35.6431 3.10505 35.4467 2.5833 35.456 2.04421C35.4654 1.50511 35.6797 0.990748 36.054 0.609488C36.4282 0.228228 36.9331 0.00983267 37.4623 0.000322611C37.9915 -0.00919127 38.5036 0.190916 38.8908 0.558489Z",
    fill: "#07D91D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueueScreenArrowRightGreen);
export default __webpack_public_path__ + "static/media/queueScreenArrowRightGreen.5656071bf0bca8c4a20efe52226a284e.svg";
export { ForwardRef as ReactComponent };